/** Outcome of a PATCH /item/:id/cell-values once its write job has settled. */
export enum DatabaseItemCellValuesWriteStatusType {
  /** The job completed, or the server wrote the values inline (unpublished drafts, jobId null). */
  Saved = 'saved',
  /** The request or the job failed; the values were not stored. */
  Failed = 'failed',
  /** The job subscription was cancelled before the outcome arrived, so nothing is known either way. */
  Unconfirmed = 'unconfirmed',
}
